<template>
  <div class="jump-page"></div>
</template>
<script>
import { getAppStatus } from '@/utils/app';

export default {
  name: 'SpdbJump3',
  data() {
    return {
      userId: getAppStatus().cuserId,
    };
  },
  computed: {
  },
  mounted() {
    let curTimestamp = new Date().getTime() / 1000;
    curTimestamp = Math.floor(curTimestamp);
    let { timestamp } = this.$route.query;
    timestamp = Number(timestamp);
    const { host } = window.location;
    let curFromPath = this.$route.path;
    let { fromPath } = this.$route.query;
    if ((curTimestamp - timestamp <= 30) && (fromPath === '/leaflet/jump' || fromPath === '/leaflet/poster')) {
      this.$router.push({
        path: '/leaflet/jump2',
        query: {
          timestamp: curTimestamp,
          fromPath: curFromPath,
        },
      });
    } else {
      window.location.replace(`//${host}/bank/404`);
    }
  },
  watch: {
    $route: {
      handler(val, from) {
      },
      immediate: true,
    },
  },
  methods: {
  },
};
</script>
<style scoped>
  .jump-page {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
</style>
